module.exports = __webpack_public_path__ + "img/120x120-3.db2c0fa4.png";